<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" min-height="150">
                    <v-flex xs11 sm11 class="text-left">
                        <h3>Import liste de prix</h3>
                    </v-flex>
                    <v-layout column>
                        <v-flex xs12 sm8 offset-1>
                            <div class="cardContainer">
                                <ul align="left">
                                    <li>Ouvrez la liste de prix .xls (Excel 97) dans Excel</li>
                                    <li>Enregistrez le fichier sous format .xlsx</li>
                                    <li>Sélectionnez la liste de prix .xlsx à importer</li>
                                </ul>
                            </div>
                            <div class="cardWrapper">
                                <input type="file" ref="priceList" accept=".xlsx" v-on:change="handlePriceListUpload(20, 'XLSX')"/>
                            </div>
                        </v-flex>					
						<v-flex class="text-left mt-3">
						<v-chip class="primary" v-if="plOk && !plExists && !newPl && !$store.state.is_loading && plExtensionOk" >
							<v-icon left color="white">mdi-timetable</v-icon>
							Attention : le processus prend quelques minutes !
						</v-chip>
					</v-flex>
                   </v-layout>
                    <v-alert :value="!plExtensionOk" type="error">Fichier .xlsx requis !</v-alert>
                    <v-alert :value="plTooBig" type="error">{{ attachment_oversize_text }}</v-alert>
                    <v-alert :value="plExists" type="warning">{{ uploadPlComment }}</v-alert>
                    <v-flex v-if="$store.state.is_loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                    <v-flex class="text-xs-center mt-3">
                        <v-alert class="white--text" v-if="$store.state.api_status === 'lp_importee'" type="success">{{ uploadPlComment }}</v-alert>
                        <v-alert class="white--text" v-if="$store.state.api_status === 'lp_non_importee'" type="error">{{ uploadPlComment }}</v-alert>
                        <v-alert class="white--text" v-if="$store.state.axios_error !== ''" typt="error"><h3>{{ $store.state.axios_error }} !</h3></v-alert>
                    </v-flex>
                    <v-card-actions>
                        <v-btn text v-if="plOk && !plExists && !newPl && !$store.state.is_loading && plExtensionOk" @click="submitPriceListFile">Importer</v-btn>
                        <v-btn text v-if="plExists" @click="cancelPlImport">Annuler</v-btn>
                        <v-btn text v-if="newPl" @click="plImportOk">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
	import axios from 'axios';

	export default {
		name: "ImportOffresConectis",

		data: function () {
			return {
				attachment_size: 0,
				attachment_oversize: false,
                attachment_oversize_text: "",
				newPl: false,
				plFile: {},
				plOk: false,
				plTooBig: false,
				plExtension: "",
				plExtensionOk: true,
				plExists: false,
				uploadPlComment: null,
            }
        },
		methods: {
			submitPriceListFile() {
				/*
					Initialize the form data
				*/
				let formData = new FormData();
				/*
					Iteate over any file sent over appending the files
					to the form data.
				*/
				formData.append("files[0]", this.plFile);
				/*
					Make the request to the POST /multiple-files URL
				*/
				var link = "http://domoserver.ddns.net/gigamedia1/priceLists/importPriceList.php";
				this.$store.state.axios_error = "";
				axios.post(link, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}).then(response => {
					this.importPriceListResponse = response;
					this.$store.state.api_status = response.data.api_status;
					this.attachment_size = response.data.attachment_size;
					if (response.data.attachment_size > 1024 * 1024) {
						this.attachment_oversize = true;
						this.attachment_oversize_text = "Fichier trop volumineux.";
						this.plOk = false;
					}
					if (response.data.api_status === "lp_existe") {
						this.plExists = true;
						this.plOk = false;
						this.newPl = false;
						this.uploadPlComment = "La liste de prix existe déjà en base de données.";
					}
					if (response.data.api_status === "lp_importee") {
						this.newPl = true;
						this.uploadPlComment = "La liste de prix a été importée en base de données";
						this.plOk = false;
					}
					if (response.data.api_status === "lp_non_importee") {
						this.newPl = true;
						this.uploadPlComment = "La liste de prix n'a pas été importée en base de données";
						this.plOk = false;
					}
					this.$store.state.axios_error = "";
				}).catch((error) => {
					this.$store.state.axios_error = error;
				});
			},
			/*
				Handles a change on the file upload
			*/
			handlePriceListUpload(fileSizeMax, fileExtension) {
				this.plFile = this.$refs.priceList.files[0];
				var fileSize = this.plFile.size;
				if (this.plFile.name.split(".").pop().toUpperCase() == fileExtension) { //check if file extension is ok
					this.plExtensionOk = true;
					this.plOk = true;
				}
				else {
					this.plExtensionOk = false;
					this.plOk = false;
				}
				if (fileSize > fileSizeMax * 1024 * 1024) { // si taille fichiers > 
					this.attachment_oversize_text = "Fichier trop volumineux (20 Mb max.)";
					this.plTooBig = true;
					this.plOk = false;
					return;
				}
				else {
					this.plTooBig = false;
					this.plOk = true;
					return;
				}
			},
			cancelPlImport() {
				const input = this.$refs.priceList;
				input.type = "text";
				input.type = "file";
				this.plExists = false;
				this.plOk = false;
				this.$store.state.api_status = "";
			},
			plImportOk() {
				this.newPl = false;
				const input = this.$refs.priceList;
				input.type = "text";
				input.type = "file";
				this.$store.state.api_status = "";
			},
			next() {
				const active = parseInt(this.$store.state.active);
				this.$store.state.active = (active < 6 ? active + 1 : 0);
			},
        }
    }
</script>
